module.exports = __webpack_public_path__ + "5a97d0ba0fa6921dd102f948b43a17bb.svg";